import clsx from 'clsx';
import { ReactComponent as Burger } from './burger.svg';
import { ReactComponent as Cross } from './cross.svg';
import { ReactComponent as Logo } from './logo-mobile.svg';
import Search from '../../shared/search';
import style from './style.module.scss';

const TopMobile = ({ toggleMenu, menuOpen, dark, isHome, homeUrl, levelClass }) => {
    return (
        <div
            className={clsx(
                style.topMobile,
                menuOpen && style.open,
                dark && style.dark,
                isHome && style.home,
                style[levelClass],
            )}
        >
            <Burger className={style.burger} onClick={toggleMenu} />
            <p className={clsx(style.title, (isHome || menuOpen) && style.visible)}>Menu</p>
            {!isHome && (
                <a href={homeUrl} className={clsx(style.logo, menuOpen && style.hide)}>
                    <Logo />
                </a>
            )}
            <Search isHeader={true} isMenuOpen={menuOpen} isHome={isHome} />
            <Cross className={style.cross} onClick={toggleMenu} />
        </div>
    );
};

export default TopMobile;
